import styled from 'styled-components'

export const Zap = styled.div`
  .whatsapp-link {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: calc(10%);
    cursor: pointer;
    text-align: center;
    z-index: 998;
    transform: scale(0.8);
    transform-origin: 0 0;
  }

`;

